export const initialFormValues = {
  email: '',
  password: '',
  confirmPassword: '',
}
